import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Container,
    Link,
    Grid,
    Text,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    Heading,
    ModalCloseButton,
    ModalBody,
} from '@chakra-ui/react';
import ChamberLogo from './Logos/ChamberLogo';
import TrecLogo from './Logos/TrecLogo';
import TetonGeoCenterLogo from './Logos/TetonGeoCenterLogo';
import ContactForm from '../ContactForm/ContactForm';

function ContactModal() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [scrollBehavior, setScrollBehavior] = React.useState('inside');
  
    return (
      <>
        <Box onClick={onOpen} cursor="pointer">
        <Link as={GatsbyLink} variant="footer-link" fontWeight="bold">
                            Email Us
                        </Link>
        </Box>
  
        <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior={scrollBehavior} size="xl" preserveScrollBarGap>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader p="8">
                <Text fontWeight='bold' mb="0" fontSize="1.25rem">
                    Email Us
                </Text>
            </ModalHeader>
            <ModalCloseButton m="4"/>
            <ModalBody>
              
              <ContactForm />
              
            </ModalBody>
          </ModalContent>
        </Modal>
      </>
    )
  }

export default function FooterMenu() {
    return (
            <Box bg="blue.500" p="12">
                <Grid templateColumns={{base: "repeat(1fr)", md: "repeat(4, 1fr)", lg: "repeat(4, 1fr)"}} gap="1em">
                   <Box>
                      <Text textTransform="uppercase" fontWeight="900" fontSize="1.5rem" color="white" mb="0">
                          Contact Us
                      </Text>
                        <Text color="white">
                        60 South Main Street<br />
                        PO Box 1557<br />
                        Driggs, Idaho 83422<br />
                        <ContactModal />
                        </Text>
                   </Box>
                    <TrecLogo />
                    {/* <ChamberLogo />
                    <TetonGeoCenterLogo /> */}
                </Grid>
                <Container maxW="container.lg" mt="4">
                    <Box>
                       <Text color="white" size="sm" mb="0" textAlign="center">TREC is a nonprofit 501(c)6, service organization. Our mission is to encourage high-value, low-impact job creation; provide value and service to the business community and enhance the overall prosperity of Teton Valley.</Text>
                    </Box>
                </Container>
            </Box>
    )
}